import { render, staticRenderFns } from "./Cashbook.vue?vue&type=template&id=7c744b12&scoped=true&"
import script from "./Cashbook.vue?vue&type=script&lang=ts&"
export * from "./Cashbook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c744b12",
  null
  
)

export default component.exports